import { Spinner } from '@squareup/dex-icons/dex/misc';
import { Box } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React from 'react';

import styles from './loading-spinner.module.css';

interface LoadingSpinnerProps {
  className?: string;
  testId?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  testId,
}) => (
  <Box
    className={clsx(styles['spinner-section'], className)}
    testId={testId ?? 'loading-spinner'}
  >
    <Spinner
      className={clsx(
        commonIconStyles['icon-spinner'],
        styles['loading-spinner']
      )}
    />
  </Box>
);

export default LoadingSpinner;
